module.exports = require("./jquery-ui.js");


//////////////////
// WEBPACK FOOTER
// jquery-ui (bower component)
// module id = 437
// module chunks = 0